"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CoordinateInfo = void 0;
var React = _interopRequireWildcard(require("react"));
var _ol = require("ol");
var _GML = _interopRequireDefault(require("ol/format/GML2"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _Logger = _interopRequireDefault(require("@terrestris/base-util/dist/Logger"));
var _typeUtils = require("../Util/typeUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var format = new _GML["default"]();
/**
 * Constructs a wrapper component for querying features from the clicked
 * coordinate. The returned features can be passed to a child component
 * to be visualized.
 *
 * @class The CoordinateInfo
 * @extends React.Component
 */
var CoordinateInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(CoordinateInfo, _React$Component);
  var _super = _createSuper(CoordinateInfo);
  /**
   * Creates the CoordinateInfo component.
   * @constructs CoordinateInfo
   */
  function CoordinateInfo(props) {
    var _this;
    _classCallCheck(this, CoordinateInfo);
    _this = _super.call(this, props);
    _this.state = {
      clickCoordinate: null,
      features: {},
      loading: false
    };
    _this.onMapClick = _this.onMapClick.bind(_assertThisInitialized(_this));
    _this.layerFilter = _this.layerFilter.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CoordinateInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var map = this.props.map;
      map.on('click', this.onMapClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var map = this.props.map;
      map.un('click', this.onMapClick);
    }
  }, {
    key: "onMapClick",
    value: function onMapClick(olEvt) {
      var _this2 = this;
      var _this$props = this.props,
        map = _this$props.map,
        featureCount = _this$props.featureCount,
        drillDown = _this$props.drillDown,
        fetchOpts = _this$props.fetchOpts,
        onSuccess = _this$props.onSuccess,
        onError = _this$props.onError;
      var mapView = map.getView();
      var viewResolution = mapView.getResolution();
      var viewProjection = mapView.getProjection();
      var pixel = map.getEventPixel(olEvt.originalEvent);
      var coordinate = olEvt.coordinate;
      var promises = [];
      var mapLayers = map.getAllLayers().filter(this.layerFilter).filter(function (l) {
        return l.getData && l.getData(pixel) && (0, _typeUtils.isWmsLayer)(l);
      });
      mapLayers.forEach(function (l) {
        var layerSource = l.getSource();
        if (!layerSource) {
          return;
        }
        var featureInfoUrl = layerSource.getFeatureInfoUrl(coordinate, viewResolution, viewProjection, {
          INFO_FORMAT: 'application/vnd.ogc.gml',
          FEATURE_COUNT: featureCount
        });
        if (featureInfoUrl) {
          promises.push(fetch(featureInfoUrl, fetchOpts[(0, _ol.getUid)(l)]));
        }
        return !drillDown;
      });
      map.getTargetElement().style.cursor = 'wait';
      this.setState({
        loading: true
      });
      Promise.all(promises).then(function (responses) {
        _this2.setState({
          clickCoordinate: coordinate
        });
        var textResponses = responses.map(function (response) {
          return response.text();
        });
        return Promise.all(textResponses);
      }).then(function (textResponses) {
        var features = {};
        textResponses.forEach(function (featureCollection, idx) {
          var fc = format.readFeatures(featureCollection);
          fc.forEach(function (feature) {
            var _id$toString;
            var id = feature.getId();
            var featureTypeName = (0, _isString2["default"])(id) ? id.split('.')[0] : (_id$toString = id === null || id === void 0 ? void 0 : id.toString()) !== null && _id$toString !== void 0 ? _id$toString : "UNKNOWN-".concat(idx);
            if (!features[featureTypeName]) {
              features[featureTypeName] = [];
            }
            features[featureTypeName].push(feature);
          });
        });
        _this2.setState({
          features: features
        }, function () {
          onSuccess(_this2.getCoordinateInfoState());
        });
      })["catch"](function (error) {
        _Logger["default"].error(error);
        onError(error);
      })["finally"](function () {
        map.getTargetElement().style.cursor = '';
        _this2.setState({
          loading: false
        });
      });
    }
  }, {
    key: "layerFilter",
    value: function layerFilter(layerCandidate) {
      var queryLayers = this.props.queryLayers;
      return queryLayers.includes(layerCandidate);
    }
  }, {
    key: "getCoordinateInfoState",
    value: function getCoordinateInfoState() {
      var featuresClone = {};
      Object.entries(this.state.features).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          layerName = _ref2[0],
          feats = _ref2[1];
        featuresClone[layerName] = feats.map(function (feat) {
          return feat.clone();
        });
      });
      var coordinateInfoState = {
        clickCoordinate: this.state.clickCoordinate ? _toConsumableArray(this.state.clickCoordinate) : null,
        loading: this.state.loading,
        features: featuresClone
      };
      return coordinateInfoState;
    }
  }, {
    key: "render",
    value: function render() {
      var resultRenderer = this.props.resultRenderer;
      return /*#__PURE__*/React.createElement(React.Fragment, null, resultRenderer(this.getCoordinateInfoState()));
    }
  }]);
  return CoordinateInfo;
}(React.Component);
exports.CoordinateInfo = CoordinateInfo;
/**
 * The defaultProps.
 */
_defineProperty(CoordinateInfo, "defaultProps", {
  queryLayers: [],
  featureCount: 1,
  drillDown: true,
  resultRenderer: function resultRenderer() {
    return /*#__PURE__*/React.createElement("div", null);
  },
  fetchOpts: {},
  onSuccess: function onSuccess() {},
  onError: function onError() {}
});
var _default = CoordinateInfo;
exports["default"] = _default;